import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

//

const badgeVariants = cva(
  "whitespace-nowrap cursor-default inline-flex items-center rounded-md border px-1.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow-sm hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/80",
        outline: "text-foreground",
        green: "border-transparent bg-emerald-100 text-emerald-600 hover:bg-emerald-100/80",
        greenOutline: "border-emerald-100 text-emerald-600 hover:bg-emerald-100/80",
        red: "border-transparent bg-rose-100 text-rose-600 hover:bg-rose-100/80",
        redOutline: "border-rose-600 text-rose-600 hover:bg-rose-100/80",
        secondary2:
          "border bg-primary-foreground text-secondary-foreground/70 hover:bg-secondary/80",
        warning: "border-transparent bg-amber-100 text-amber-600",
        none: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

//

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  tooltip?: {
    content: React.ReactNode;
    /**
     * Миллисекунды, по умолчанию 700
     */
    delayDuration?: number;
  };
}

//

function Badge({ className, variant, tooltip, ...props }: BadgeProps) {
  const component = <div className={cn(badgeVariants({ variant }), className)} {...props} />;

  return tooltip ? (
    <Tooltip delayDuration={tooltip.delayDuration ?? 0}>
      <TooltipTrigger asChild>{component}</TooltipTrigger>
      <TooltipContent>{tooltip.content}</TooltipContent>
    </Tooltip>
  ) : (
    component
  );
}

//

export { Badge, badgeVariants };
